import _ from 'lodash';
import Vue from 'vue';
import { OrderDetails, IProduct } from '@/service/types';
import { IProductState, IParamUpdateQuantity, IProductStateDict } from '@/store/types';

export default {
  UPDATE_PRODUCTS(state: IProductState, payload: IProductStateDict) {
    state.products = payload;
  },
  UPDATE_PRODUCT(state: IProductState, payload: IProduct) {
    Vue.set(state.products, payload.id, payload);
  },
  UPDATE_OTHER_PRODUCT(state: IProductState, payload: IProduct) {
    Vue.set(state.otherProducts, payload.id, payload);
  },
};
